import { defineStore } from 'pinia'
import { minValueFreeShip,shippingFeeStandard } from '~/utilities/data'

export const useCartStore = defineStore('cart', {
    
    state: () => (
        {
            data: [],
            shippingCost: shippingFeeStandard,
            minFreeShip: minValueFreeShip,
            shippingFeeStd: shippingFeeStandard
        }
    ),
    persist: true,

    getters: {
        cartList(state) {
            return state.data;
        },

        //Get all names to send to email template with line breaks
        cartItemsDescription(state) {
            let itemsDescr = "";
            state.data.forEach((product) => {
                itemsDescr = itemsDescr + product.name +" ("+ product.qty +"x R"+ product.price +")<br />";
            })
            return itemsDescr;
        },

        //Get total price per item to send to email template with line breaks
        cartItemsSum(state) {
            let itemsSum = "";
            state.data.forEach((product) => {
                itemsSum = itemsSum + "R"+ product.sum +"<br />";
            })
            //console.log("CartItemSum >"+ itemsSum+"<");
            return itemsSum;
        },
        
        priceTotal(state) {
            return state.data.reduce( ( acc, cur ) => {
                return acc + cur.sum
            }, 0 );
        },

        isShippingFree(state) {
            // console.log("isShippingFree: PriceTotal "+ this.priceTotal +"   min free ship amount >"+ state.minFreeShip+"<");
            return this.priceTotal > state.minFreeShip;
        },

        checkoutPriceTotal(state) {
            // console.log("CheckoutPriceTotal: PriceTotal "+ this.priceTotal +"   shipping cost >"+ state.shippingCost +"<");
            return this.priceTotal + state.shippingCost;
        },
        qtyTotal(state) {
            return state.data.reduce( ( acc, cur ) => {
                return acc + parseInt( cur.qty, 10 );
            }, 0 );
        },   
        // isInCart (state) => ( product ) => {
        //     return state.data.find( item => item.id == product.id ) ? true : false;
        // },
        
        canAddToCart: (state) => (product, qty=1) => {
                //See if there is still enough stock available to allow item to be added to cart
                var find = state.data.find(item => item.id == product.id)
                if (find) {
                    if (product.stock == 0 || (product.stock < (find.qty + qty)))
                        return false
                    else
                        return true
                } else {
                    if (product.stock == 0 || (product.stock < qty))
                        return false
                    else
                        return true
                }
        }
    },

    actions: {
        addToCart (payload) {
            const { $showToast } = useNuxtApp()
            if ( !this.canAddToCart( payload.product, payload.qty ) ) {
                $showToast("Sorry, we have limited stock. Try a smaller amount or contact us.", "error", 5000);
                return;
            }
            // console.log("Adding to cart: "+ payload.product.name +"   price >"+ payload.product.price +"<");
            let findIndex = this.data.findIndex( item => item.id == payload.product.id );
            let qty = payload.qty ? payload.qty : 1;
            //Check if already added to cart and if still have stock to add
            if ( findIndex !== -1 && payload.product.variants.length > 0 ) {
                findIndex = this.data.findIndex( item => item.name == payload.product.name );
            }
            
            if ( findIndex !== -1 ) {
                this.data = this.data.reduce( ( acc, product, index ) => {
                    // console.log("findIndex: "+ findIndex +"   index >"+ index +"<");
                    if ( findIndex == index ) {
                        //If specific product already added, increase specified quantities
                        acc.push( {
                            ...product,
                            qty: product.qty + qty,
                            sum: ( payload.product.sale_price ? payload.product.sale_price : payload.product.price ) * ( product.qty + qty )
                        } );
                    } else {
                        acc.push( product );
                    }
                    return acc;
                }, [] );
            } else {
                this.data = [
                    ...this.data,
                    {
                        ...payload.product,
                        qty: qty,
                        price: payload.product.sale_price ? payload.product.sale_price : payload.product.price,
                        sum: qty * ( payload.product.sale_price ? payload.product.sale_price : payload.product.price )
                    }
                ];
            }

            this.verifyFreeShipping();
            $showToast("Product added to cart.", "success");
        },

        removeFromCart (payload) {
            this.data = this.data.filter( item => {
                if ( item.id !== payload.product.id ) return true;
                if ( item.name !== payload.product.name ) return true;
                return false;
            } );

            this.verifyFreeShipping();
            const { $showToast } = useNuxtApp()
            $showToast("Product removed from cart", "info", 1500);

        },

        updateProductQty (qtyAmount, product) {
            this.data = this.data.reduce((acc, cur) => {
                if (cur.name == product.name)
                    return [
                        ...acc,
                        {
                            ...cur,
                            qty: qtyAmount,
                            sum:
                                (product.sale_price
                                    ? product.sale_price
                                    : product.price) * qtyAmount
                        }
                    ];
                return [...acc, cur];
            }, []);

            this.verifyFreeShipping();
            const { $showToast } = useNuxtApp()
            $showToast("Item amount successfully updated", "info", 1500);
            
        },

        updateCart (payload) {        
            this.data = payload.cartItems.reduce( ( acc, cur ) => {
                return [
                    ...acc,
                    {
                        ...cur,
                        sum: ( cur.sale_price ? cur.sale_price : cur.price ) * cur.qty
                    }
                ]
            }, [] );

            this.verifyFreeShipping();
            const { $showToast } = useNuxtApp()
            $showToast("Cart successfully updated", "info", 1000);

        },

        updateShipping ( payload ) {
            //commit( UPDATE_SHIPPING, payload );
            // console.log("updateShipping: cost >"+ payload.cost +"<");
            this.shippingCost = payload.cost;
            // const { $showToast } = useNuxtApp()
            // $showToast("Shipping updated", "info", 1000);

        },

        verifyFreeShipping () {
            if (this.isShippingFree ) {
                this.updateShipping( {cost: 0} );
            } else {
                this.updateShipping( {cost: this.shippingFeeStd } );
            }

        },

        clearCart () {
            //commit( CLEAR_CART, payload );
            this.data = [];
            //this.$reset()
            // this._vm.$vToastify.setSettings( {
            //     withBackdrop: false,
            //     position: "top-right",
            //     successDuration: 1500,
            // } );
            // this._vm.$vToastify.success( "Cart cleared" );
            const { $showToast } = useNuxtApp()
            $showToast("Cart cleared", "info", 1500);

        }
    }
    
})